import * as React from "react";
import { connect } from "react-redux";

import ResponsiveImage from "../../controls/ResponsiveImage";

import LoginOrCreateProfile from "../../widgets/LoginOrCreateProfile";
import HowItWorksElimination from "../../widgets/HowItWorksElimination";
import HowItWorksPickEm from "../../widgets/HowItWorksPickEm";
import LeagueShareLink from "../../controls/LeagueShareLink";

import { IState } from "../../../state/state";
import { IAction } from "../../../actions";

export interface IHomeProps {
    dispatch: (action: IAction) => void,
    authenticationToken: string,
}

const loggedInSection = (props: IHomeProps) => {
    if (props && props.authenticationToken != null) {
        return (
            <span>
                <p>No worries here. Looks like you're already logged in!</p>
            </span>
        );
    } else {
        return (
            <span>
                <p>Just create a profile, or log in if you already have one.</p>
                <LoginOrCreateProfile />
            </span>
        );
    }
}

const freeRollLinks = (props: IHomeProps): JSX.Element => {
    // return (<span/>);
    return (
        <table>
            <tbody>
                <tr>
                    <td className="plain-table-padding">Free 2026 Free Pick'Em League</td>
                    <td className="plain-table-padding"><span className="glyphicon glyphicon-arrow-right" aria-hidden="true"/></td>
                    <td className="plain-table-padding">
                        <a className="btn btn-pickem-blue" href="/#/inviteVerify?g=d77bf853-3bfc-441a-a1cc-446b86f044bb"><i className="fa fa-rocket" aria-hidden="true"/> Click Here</a>
                    </td>
                </tr>
                <tr>
                    <td className="plain-table-padding">Invite Friends!</td>
                    <td className="plain-table-padding"><span className="glyphicon glyphicon-arrow-right" aria-hidden="true"/></td>
                    <td className="plain-table-padding">
                        <LeagueShareLink top="0px" altImage={true} guid="6a3f9904-ac94-4aa5-8a2f-e5c0e9fe5a7b" message="Pick'Em Leagues - Free 2026 Pick'Em League" />
                    </td>
                </tr>                
                <tr>
                    <td className="plain-table-padding">2026 Free Pick'Em vs Spread League</td>
                    <td className="plain-table-padding"><span className="glyphicon glyphicon-arrow-right" aria-hidden="true"/></td>
                    <td className="plain-table-padding">
                        <a className="btn btn-pickem-blue" href="/#/inviteVerify?g=838c0c11-e720-4369-be8c-ab415d57161f"><i className="fa fa-rocket" aria-hidden="true"/> Click Here</a>
                    </td>
                </tr>
                <tr>
                    <td className="plain-table-padding">Invite Friends!</td>
                    <td className="plain-table-padding"><span className="glyphicon glyphicon-arrow-right" aria-hidden="true"/></td>
                    <td className="plain-table-padding">
                        <LeagueShareLink top="0px" altImage={true} guid="d5c482b5-24c3-42c5-b6cb-0c08152b0ef2" message="Pick'Em Leagues - Free 2026 Pick'Em vs Spread League" />
                    </td>
                </tr>
                {/* Suicide league hidden from home page
                <tr>
                    <td className="plain-table-padding">Free 2026 Free Suicide League</td>
                    <td className="plain-table-padding"><span className="glyphicon glyphicon-arrow-right" aria-hidden="true"/></td>
                    <td className="plain-table-padding">
                        <a className="btn btn-pickem-blue" href="/#/inviteVerify?g=510bd19c-e71d-4425-b49d-5cf7807b658b"><i className="fa fa-rocket" aria-hidden="true"/> Click Here</a>
                    </td>
                </tr>
                <tr>
                    <td className="plain-table-padding">Invite Friends!</td>
                    <td className="plain-table-padding"><span className="glyphicon glyphicon-arrow-right" aria-hidden="true"/></td>
                    <td className="plain-table-padding">
                        <LeagueShareLink top="0px" altImage={true} guid="d469c340-6083-4eee-8c66-1f5d207d75eb" message="Pick'Em Leagues - Free 2026 Suicide League" />
                    </td>
                </tr>
                */}
                <tr>
                    <td className="plain-table-padding">2026 Free Touchdown Pick'Em League</td>
                    <td className="plain-table-padding"><span className="glyphicon glyphicon-arrow-right" aria-hidden="true"/></td>
                    <td className="plain-table-padding">
                        <a className="btn btn-pickem-blue" href="/#/inviteVerify?g=b9f76824-e4bc-4f1d-9f27-9792bcd57ffa"><i className="fa fa-rocket" aria-hidden="true"/> Click Here</a>
                    </td>
                </tr>
                <tr>
                    <td className="plain-table-padding">Invite Friends!</td>
                    <td className="plain-table-padding"><span className="glyphicon glyphicon-arrow-right" aria-hidden="true"/></td>
                    <td className="plain-table-padding">
                        <LeagueShareLink top="0px" altImage={true} guid="0b6a5b91-8e90-4932-8183-34fe793c1225" message="Pick'Em Leagues - Free 2026 Touchdown Pick'Em League" />
                    </td>
                </tr>            
            </tbody>
        </table>
    );
}

const Home = (props: IHomeProps) => {

    return (
        <div>        
            <div className="jumbotron">
            </div>
            
            <h2 className="tight-panel"><img src="/img/new/works-32x32.png" className="icon32" alt=""/> How It Works</h2>
            <div className="content-panel">
                <ul>
                    <li>It's FREE.</li>
                    <li>You pick who wins. Nice and simple, and quick.</li>
                    <li>Pick correctly and get points! Pick incorrectly and... no points.</li>
                    <li>There are four types of leagues: Pick'Em, Pick'Em vs Spread, Elimination, and Touchdown Pick'Em.</li>
                    <li><b>Pick'Em:</b> players pick every game, every week, through the whole season.</li>
                    <li><b>Pick'Em vs Spread:</b> just like Pick'Em, but versus the spread.</li>
                    <li><b>Touchdown Pick'Em:</b> just like Pick'Em, but also pick a winning margin for extra points.</li>
                    <li><b>Elimination:</b> players pick ONE game, every week. One wrong pick and they are eliminated!.</li>
                    <li>READ ON! JOIN UP! VICTORY AWAITS!</li>                    
                </ul>
                {freeRollLinks(props)}
            </div>

            <h3 className="tight-panel"><img src="/img/new/profile-32x32.png" className="icon32" alt=""/> You Need A Profile</h3>
            <div className="content-panel">
                {loggedInSection(props)}
            </div>

            <h3 className="tight-panel"><img src="/img/new/leagues-32x32.png" className="icon32" alt=""/> Create or Join Leagues</h3>
            <div className="content-panel">
                <p>On the My Leagues page, you can create or join a league or leagues.</p>
                <p>Or, if you received an invite email, clicking the link in the email takes care of all that.</p>
                <p>There are four league types - "Pick'Em", "Pick'Em vs Spread", "Elimination", and "Touchdown Pick'Em".</p>
                <ResponsiveImage fileName="leagues.png" />
            </div>
        
            <h3 className="tight-panel"><img src="/img/new/invite-32x32.png" className="icon32" alt=""/> Invite Friends</h3>
            <div className="content-panel">
                <p>The more, the merrier! Leagues have no size limit.</p>
                <p>Note: you can only invite friends to leagues where you are the owner.</p>
                <ResponsiveImage fileName="invite.png" />
            </div>
 
            <HowItWorksPickEm />

            <HowItWorksElimination />

            <h3 className="tight-panel"><img src="/img/new/academic-cap-32x32.png" className="icon32" alt=""/> That's It!</h3>
            <div className="content-panel">              
                <p>We're working on a ton of other features, but that's where we are today.</p>
                <p>Have ideas? Send 'em over! <a href="mailto:big-ideas@pickemleagues.com">big-ideas@pickemleagues.com</a></p>
                <p><a href="/#/privacy">Privacy Policy</a></p>
                <p><a href="/#/tos">Terms of Service</a></p>
            </div>
        </div>
    );
}

function mapStateToProps(state: IState) {
    return {
        authenticationToken: state.authenticationToken
    };
}

export default connect(mapStateToProps)(Home as any);
